const blocks = document.querySelectorAll('.singlePost__case-block');

blocks.forEach((block, index) => {
  const nextBlock = blocks[index + 1];
  const currentHalf = block.offsetHeight / 2;
  const nextHalf = nextBlock.offsetHeight / 2;
  const result = currentHalf + nextHalf + 56;
  block.style.setProperty('--case-offset', `${result}px`);
});